const subUsersValidationES = {
    "add": {
        "first_name": {
            "required": "Se requiere el nombre"
        },
        "last_name": {
            "required": "Se requiere el apellido"
        },
        "email": {
            "required": "Se requiere el correo electrónico",
            "invalid": "El correo electrónico no es válido",
            "unique": "El correo electrónico está asociado con otro usuario"
        },
        "username": {
            "required": "Se requiere el nombre de usuario",
            "stringCaseLower": "El nombre de usuario debe estar en minúsculas",
            "regexp": "El nombre de usuario debe consistir solo en letras y números",
            "unique": "El nombre de usuario está asociado con otro usuario",
            "invalid": "El nombre de usuario no es válido"
        },
        "password": {
            "required": "Se requiere la contraseña",
            "regexp": "La contraseña debe consistir en al menos 10 caracteres, incluyendo 1 letra mayúscula y 1 carácter especial"
        },
        "confirmPassword": {
            "required": "Por favor confirme la contraseña",
            "identical": "La contraseña y la confirmación de la contraseña deben coincidir"
        },
        "contract_expiry": {
            "required": "Se requiere la fecha de vencimiento del contrato"
        },
        "sub_user_deal": {
            "required": "Se requiere el acuerdo del subusuario",
            "between": "El acuerdo del subusuario debe estar entre 0 y 100"
        },
        "street_and_number": {
            "required": "Se requiere la calle y el número de casa"
        },
        "postal_code": {
            "required": "Se requiere el código postal"
        },
        "city": {
            "required": "Se requiere la ciudad"
        },
        "country": {
            "required": "Se requiere el país"
        },
        "phone": {
            "required": "Se requiere el número de teléfono"
        }
    },
    "update": {
        "first_name": {
            "required": "Se requiere el nombre"
        },
        "last_name": {
            "required": "Se requiere el apellido"
        },
        "email": {
            "required": "Se requiere el correo electrónico",
            "invalid": "El correo electrónico no es válido"
        },
        "username": {
            "required": "Se requiere el nombre de usuario",
            "stringCaseLower": "El nombre de usuario debe estar en minúsculas",
            "regexp": "El nombre de usuario debe consistir solo en letras y números"
        },
        "contract_expiry": {
            "required": "Se requiere la fecha de vencimiento del contrato"
        },
        "sub_user_deal": {
            "required": "Se requiere el acuerdo del subusuario",
            "between": "El acuerdo del subusuario debe estar entre 0 y 100"
        },
        "street_and_number": {
            "required": "Se requiere la calle y el número de casa"
        },
        "postal_code": {
            "required": "Se requiere el código postal"
        },
        "city": {
            "required": "Se requiere la ciudad"
        },
        "country": {
            "required": "Se requiere el país"
        },
        "phone": {
            "required": "Se requiere el número de teléfono"
        }
    }
};

export default subUsersValidationES;